import React, { useState, useEffect, useMemo } from "react";
import PropTypes from "prop-types";
import AppContext from "./context/Context";
import { settings } from "./config";
import toggleStylesheet from "./helpers/toggleStylesheet";
import { getItemFromStore, setItemToStore, themeColors } from "./helpers/utils";
import { toast } from "react-toastify";
import { useHistory, useLocation } from "react-router-dom";
import axios from "axios";
import authHeader from "./services/authenticationHeader";
import apiURL from "./services/apiURL";

const Main = (props) => {
  const [isFluid, setIsFluid] = useState(getItemFromStore("isFluid", settings.isFluid));
  const [isRTL, setIsRTL] = useState(getItemFromStore("isRTL", settings.isRTL));
  const [isDark, setIsDark] = useState(getItemFromStore("isDark", settings.isDark));
  const [isTopNav, setIsTopNav] = useState(getItemFromStore("isTopNav", settings.isTopNav));
  const [isCombo, setIsCombo] = useState(getItemFromStore("isCombo", settings.isCombo));
  const [isVertical, setIsVertical] = useState(getItemFromStore("isVertical", settings.isVertical));
  const [isLoggedIn, setIsLoggedIn] = useState(getItemFromStore("isLoggedIn", settings.isLoggedIn));
  const [isNavbarVerticalCollapsed, setIsNavbarVerticalCollapsed] = useState(
    getItemFromStore("isNavbarVerticalCollapsed", settings.isNavbarVerticalCollapsed)
  );
  const [currency, setCurrency] = useState(settings.currency);
  const [showBurgerMenu, setShowBurgerMenu] = useState(settings.showBurgerMenu);
  const [isLoaded, setIsLoaded] = useState(false);
  const [isOpenSidePanel, setIsOpenSidePanel] = useState(false);
  const [navbarCollapsed, setNavbarCollapsed] = useState(false);
  const [remember, setRemember] = useState(false);
  const [loginUserDetails, setLoginUserDetails] = useState(getItemFromStore("tempData", {}));
  const [navbarStyle, setNavbarStyle] = useState(getItemFromStore("navbarStyle", settings.navbarStyle));
  const [redirectFromPayment, setRedirectFromPayment] = useState(false);
  const [rememberEmail, setRememberEmail] = useState("");
  const [rememberPass, setRememberPass] = useState("");
  const [accessToken, setAccessToken] = useState("");
  const [isValidLogin, setIsValidLogin] = useState(false);
  const [loginResponse, setLoginResponse] = useState({});
  const [isAccountRecoveryModel, setIsAccountRecoveryModel] = useState(false);

  const toggleModal = () => setIsOpenSidePanel(false);
  const value = {
    isRTL,
    isDark,
    isCombo,
    isFluid,
    setIsRTL,
    isTopNav,
    currency,
    remember,
    setIsDark,
    setIsCombo,
    setIsFluid,
    isVertical,
    toggleModal,
    rememberEmail,
    rememberPass,
    accessToken,
    isValidLogin,
    setIsTopNav,
    navbarStyle,
    setCurrency,
    setIsVertical,
    showBurgerMenu,
    redirectFromPayment,
    setNavbarStyle,
    isOpenSidePanel,
    navbarCollapsed,
    setShowBurgerMenu,
    setIsOpenSidePanel,
    setNavbarCollapsed,
    isNavbarVerticalCollapsed,
    setIsNavbarVerticalCollapsed,
    loginUserDetails,
    setLoginUserDetails,
    setRedirectFromPayment,
    setRemember,
    setRememberEmail,
    setRememberPass,
    setAccessToken,
    setIsValidLogin,
    isLoggedIn,
    setIsLoggedIn,
    loginResponse, 
    setLoginResponse,
    isAccountRecoveryModel, 
    setIsAccountRecoveryModel
  };

  let history = useHistory();

  // useEffect(() => {
  //   if (Object.keys(loginUserDetails).length > 0) {
  //     setIsValidLogin(true);
  //   }
  // }, [loginUserDetails]);

  // useEffect(async () => {
  //   debugger;
  //   let body = {
  //     username: localStorage.getItem("usr"),
  //   };
  //   try {
  //     const accessToken = await axios.post("http://localhost:5001/authentication/refresh-token", body);
  //   } catch (err) {
  //     console.log(err);
  //     window.location.href = "/v4/portal/authentication/login";
  //   }
  //   console.log(accessToken);

  //   if (accessToken.data) {
  //     setAccessToken(accessToken.data);
  //     const aboutMe = await axios.get("http://localhost:5001/authentication/whoisme", {
  //       params: { username: localStorage.getItem("usr") },
  //       headers: { Authorization: "Bearer " + accessToken.data, "Content-Type": "application/json" },
  //     });
  //     setLoginUserDetails(aboutMe.data.items);
  //   }
  // }, []);
  const API_URL = apiURL("authentication")
  useMemo(() => {
    if (window.location.href.includes("ed=")) {
      let body = {
        ed: window.location.href.split("ed=")[1],
      };
      axios
        .post(`${API_URL}/nda_authentication`, body, { withCredentials: true })//with credentials is used here to store cookies recived in response
        .then((res) => {
          localStorage.setItem("isLoggedIn", true);//added this so it does not get redirected to login page 
          setLoginUserDetails(res.data.items);
        })
        .catch((error) => {
          const resMessage =
            (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
          toast.error(resMessage);
          // toast.warning(error.response.data.long_message + " " + error.response.data.more_information);
        });
    }
  }, []);

  const setStylesheetMode = (mode) => {
    setIsLoaded(false);
    setItemToStore(mode, value[mode]);
    toggleStylesheet({ isRTL, isDark }, () => setIsLoaded(true));
  };

  useEffect(() => {
    setStylesheetMode("isFluid");
    // eslint-disable-next-line
  }, [isFluid]);

  useEffect(() => {
    setStylesheetMode("isRTL");
    // eslint-disable-next-line
  }, [isRTL]);

  useEffect(() => {
    setStylesheetMode("isDark");
    // eslint-disable-next-line
  }, [isDark]);

  useEffect(() => {
    setItemToStore("isNavbarVerticalCollapsed", isNavbarVerticalCollapsed);
    // eslint-disable-next-line
  }, [isNavbarVerticalCollapsed]);

  useEffect(() => {
    setItemToStore("isTopNav", isTopNav);
    // eslint-disable-next-line
  }, [isTopNav]);

  useEffect(() => {
    setItemToStore("isCombo", isCombo);
    // eslint-disable-next-line
  }, [isCombo]);
  useEffect(() => {
    setItemToStore("isVertical", isVertical);
    // eslint-disable-next-line
  }, [isVertical]);

  useEffect(() => {
    setItemToStore("navbarStyle", navbarStyle);
    // eslint-disable-next-line
  }, [navbarStyle]);

  useEffect(() => {
    setItemToStore("isLoggedIn", isLoggedIn);
    // eslint-disable-next-line
  }, [isLoggedIn]);

  useEffect(() => {
    window.addEventListener('load', function() {
      localStorage.removeItem('pass_word');
      localStorage.removeItem('api_plus_plus');
      if (!isLoggedIn || (isLoggedIn && !window.location.href.includes("/admin/billing"))) {
        localStorage.removeItem('quickbook_tkn');    
      }
    });
  }, []);
  

  if (!isLoaded) {
    toggleStylesheet({ isRTL, isDark }, () => setIsLoaded(true));
    return (
      <div
        style={{
          position: "fixed",
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
          backgroundColor: isDark ? themeColors.dark : themeColors.light,
        }}
      />
    );
  }
  return <AppContext.Provider value={value}>{props.children}</AppContext.Provider>;
};

Main.propTypes = { children: PropTypes.node };

export default Main;
